export default "__VITE_ASSET__CojHfmpB__"